import * as React from 'react';
import devNote from '@xingternal/dev-note';
import * as Styled from './skeleton-button.styles';
export const SkeletonButton = ({ className, size = 'medium', sizeConfined, sizeWide, variant, ...props }) => {
    if (variant) {
        devNote.deprecate("The variant property is deprecated and should be removed. Variant 'secondary' is automatically mapped to 'primary'.");
    }
    return (React.createElement(Styled.Button, { "$size": size, "$sizeConfined": sizeConfined, "$sizeWide": sizeWide, className: className, "data-xds": "SkeletonButton", ...props }));
};
SkeletonButton.displayName = 'SkeletonButton';
//# sourceMappingURL=skeleton-button.js.map